
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auto-parts/models/[brand]",
      function () {
        return require("private-next-pages/auto-parts/models/[brand].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auto-parts/models/[brand]"])
      });
    }
  